<template>
    <div>
        <price-element-min-pax :amount.sync="service.minPax"></price-element-min-pax>
        <price-element-max-pax :amount.sync="service.maxPax"></price-element-max-pax>
        <div class="d-flex justify-content-start mb-4">
            <core-number-input
                :label="$t('components.price.element.nights.label')"
                :amount.sync="service.duration"
            ></core-number-input>
            <core-days-picker :days.sync="service.arrivalDays"></core-days-picker>
        </div>
        <price-element-breakfast :breakfast.sync="service.breakfast"></price-element-breakfast>
    </div>
</template>

<script>
export default {
  data () {
    return {
      priceRule: {}
    }
  },
  props: {
    service: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/Perunitperperiod.vue